const KEY = "cdm_session";

export function setSession(token, username) {
  localStorage.setItem(KEY, JSON.stringify({ token, username }));
}

export function getSession() {
  try {
    const s = localStorage.getItem(KEY);
    return s ? JSON.parse(s) : null;
  } catch {
    return null;
  }
}

export function getSessionToken() {
  return getSession()?.token || null;
}

export function clearSession() {
  localStorage.removeItem(KEY);
}

// Silently swaps in a freshly-signed token (from GET /api/me's session_jwt)
// without disturbing the stored username. No-ops if none was returned.
export function updateSessionToken(token) {
  if (!token) return;
  try {
    const s = getSession();
    localStorage.setItem(KEY, JSON.stringify({ token, username: s?.username || "" }));
  } catch {
    // ignore
  }
}

// True only if a token exists AND (when it is a readable JWT) has not expired.
export function isSessionActive() {
  const token = getSessionToken();
  if (!token) return false;
  try {
    const payload = token.split(".")[1];
    const json = JSON.parse(atob(payload.replace(/-/g, "+").replace(/_/g, "/")));
    if (json.exp && json.exp * 1000 < Date.now()) return false;
    return true;
  } catch {
    // Not a decodable JWT: let the server's /me check decide.
    return true;
  }
}
